import React from "react";
import { SettingsListRuntimeProvider } from "../../../../../shared/frontend/settings/settingsListRuntimeContext";
import { useBaseSettingsListRuntime } from "./useSettingsListRuntime";

/** Laufzeit für Shared-Listen ohne eigenen Adapter (`ManagedTableCard`/`ManagedTableList`); einmal an der App-Wurzel. */
export function SettingsListRuntimeRoot({ children }: { children: React.ReactNode }) {
  const runtime = useBaseSettingsListRuntime();
  return <SettingsListRuntimeProvider value={runtime}>{children}</SettingsListRuntimeProvider>;
}
